// extracted by mini-css-extract-plugin
export var footerStyle = "footer-module--footerStyle--2smTq";
export var logos = "footer-module--logos--3o9Fj";
export var blurb = "footer-module--blurb--1xa5f";
export var copyright = "footer-module--copyright--3yIxz";
export var footerNavList = "footer-module--footerNavList--QoE0l";
export var footerNavListItem = "footer-module--footerNavListItem--eueiL";
export var links = "footer-module--links--3GubR";